import { PageContent } from '@app/components/page/PageContent';
import { PageHeaderSkeleton } from '@app/components/page/header/skeleton/PageHeaderSkeleton';
import { SocialExportUploadLayout } from './SocialExportUploadLayout';
import { Box, Skeleton } from '@mui/material';

/** Placeholder tiles for the platform switcher bar (typical station platform count). */
const PLATFORM_PICKER_SLOTS = 7;

/**
 * Shared loading layout for fragment and composition social export upload screens.
 * Mirrors SocialExportUploadLayout: form sections left, video preview right (under media on sm-).
 */
export function SocialExportUploadLayoutSkeleton() {
  return (
    <>
      <PageHeaderSkeleton breadcrumbs={3} />
      <PageContent maxWidth="lg">
        <SocialExportUploadLayout
          platform={
            <Box sx={{ mb: 4 }}>
              <Skeleton variant="text" width={96} sx={{ typography: 'caption', mb: 1.5 }} />
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {Array.from({ length: PLATFORM_PICKER_SLOTS }, (_, index) => (
                  <Skeleton key={index} variant="rounded" width={108} height={72} />
                ))}
              </Box>
            </Box>
          }
          media={
            <Box sx={{ mb: 4 }}>
              <Skeleton variant="text" width={140} sx={{ typography: 'caption', mb: 1.5 }} />
              <Skeleton variant="rounded" width="100%" height={56} />
            </Box>
          }
          preview={
            <Box sx={{ mb: 4 }}>
              <Skeleton variant="text" width={168} sx={{ typography: 'caption', mb: 1.5 }} />
              <Skeleton variant="rounded" width="100%" sx={{ aspectRatio: '16 / 9' }} />
            </Box>
          }
          form={
            <>
              <Box sx={{ mb: 4 }}>
                <Skeleton variant="text" width={168} sx={{ typography: 'caption', mb: 1.5 }} />
                <Skeleton variant="rounded" width={360} height={40} sx={{ maxWidth: 1 }} />
              </Box>

              <Box sx={{ mb: 4 }}>
                <Skeleton variant="text" width={96} sx={{ typography: 'caption', mb: 1.5 }} />
                <Skeleton variant="rounded" width="100%" height={40} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="100%" height={100} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="66%" height={40} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="83%" height={40} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="83%" height={40} />
              </Box>

              <Box sx={{ mb: 4 }}>
                <Skeleton variant="text" width={200} sx={{ typography: 'caption', mb: 1.5 }} />
                <Skeleton variant="rounded" width="66%" height={40} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="66%" height={40} sx={{ mb: 4 }} />
                <Skeleton variant="rounded" width="66%" height={40} />
              </Box>

              <Box display="flex" justifyContent="flex-end" gap={1}>
                <Skeleton variant="rounded" width={88} height={36} />
                <Skeleton variant="rounded" width={120} height={36} />
              </Box>
            </>
          }
        />
      </PageContent>
    </>
  );
}
